(function () {
  const STORAGE_KEY = 'headerNavRoot';

  function isContextPage() {
    return (
      document.body.classList.contains('template-product') ||
      document.body.classList.contains('template-collection')
    );
  }

  function findNavRootFromClick(target) {
    const link = target.closest('a[href]');
    if (!link) return null;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return null;
    }

    if (link.dataset.headerNavRoot) return link.dataset.headerNavRoot;

    const root = link.closest('[data-header-nav-root]');
    return root ? root.dataset.headerNavRoot : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      const inHeaderNav =
        event.target.closest('.header__inline-menu') || event.target.closest('.menu-drawer__navigation');
      if (!inHeaderNav) return;

      const navRoot = findNavRootFromClick(event.target);
      if (navRoot) sessionStorage.setItem(STORAGE_KEY, navRoot);
    },
    true
  );

  function getTopLevelMenuSpans(menu) {
    return menu.querySelectorAll(
      '.list-menu--inline > li > header-menu summary.header__menu-item .header__menu-item-link > span:first-child, ' +
        '.list-menu--inline > li > header-menu summary.header__menu-item > span:first-child, ' +
        '.list-menu--inline > li > a.header__menu-item > span:first-child'
    );
  }

  function applyHeaderNavActive() {
    if (!isContextPage()) return;

    const menu = document.querySelector('.header__inline-menu');
    if (!menu) return;

    let navRoot = sessionStorage.getItem(STORAGE_KEY);

    if (!navRoot && menu.dataset.navFallbackRoot) {
      navRoot = menu.dataset.navFallbackRoot;
      sessionStorage.setItem(STORAGE_KEY, navRoot);
    }

    if (!navRoot) return;

    getTopLevelMenuSpans(menu).forEach(function (span) {
      span.classList.remove('header__active-menu-item');
    });

    const trigger = menu.querySelector('#HeaderMenu-' + navRoot);
    if (!trigger) return;

    const span =
      trigger.querySelector('.header__menu-item-link > span:first-child') ||
      trigger.querySelector('span:first-child');
    if (span) span.classList.add('header__active-menu-item');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHeaderNavActive);
  } else {
    applyHeaderNavActive();
  }
})();
